import api from '.';

export const SUB_ACCIONES_ENDPOINT = '/sub-acciones';
export const SUB_ACCIONES_ENDPOINT_KVP_ENDPOINT = `${SUB_ACCIONES_ENDPOINT}/{idAccion}/kvp`;

export const getSubAccionesByAccionAsKvpList = async (idAccion) => {
    const response = await api.get(`${SUB_ACCIONES_ENDPOINT}/${idAccion}/kvp`);
    return response;
};
